import { Component, computed, inject } from '@angular/core';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-count-rejected-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-rejected-packages.component.html',
    standalone: true,
    styleUrl: './count-rejected-packages.component.scss'
})
export class CountRejectedPackagesComponent {

    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    rejectedPackagesCountResult = toSignal(
        this._packageService.countPackageResponses('rejected').pipe(
            catchError(() => of(null))
        )
    );

    rejectedPackages = computed(() => this.rejectedPackagesCountResult()?.count);

    getPackageCount(): number {
        return this.rejectedPackages() && Number(this.rejectedPackages()) > 0 ? Number(this.rejectedPackages()) : 0;
    }

}
